import {memo} from "react";

import {type CalendarDay, CalendarDays} from "./calendar-days";
import {CalendarHeader} from "./calendar-header";
import {CalendarWeekdays} from "./calendar-weekdays";

interface CalendarProps {
    month: number;
    year: number;
    weekdays: ReadonlyArray<string>;
    days: ReadonlyArray<CalendarDay>;
    showLeftNav: boolean;
    showRightNav: boolean;
    disableLeftNav?: boolean;
    disablePreviousYear?: boolean;
    onPreviousYear?: () => void;
    onPreviousMonth?: () => void;
    onNextMonth?: () => void;
    onNextYear?: () => void;
    onDayClick: (day: CalendarDay) => void;
    onDayHover: (date: Date) => void;
    onDayLeave: () => void;
    getDayTooltip?: (date: Date) => string | null | undefined;
    getDayClassName?: (date: Date) => string | null | undefined;
    hideOtherMonthDaysContent?: boolean;
}

export const Calendar = memo(function Calendar({
    month,
    year,
    weekdays,
    days,
    showLeftNav,
    showRightNav,
    disableLeftNav = false,
    disablePreviousYear,
    onPreviousYear,
    onPreviousMonth,
    onNextMonth,
    onNextYear,
    onDayClick,
    onDayHover,
    onDayLeave,
    getDayTooltip,
    getDayClassName,
    hideOtherMonthDaysContent,
}: CalendarProps) {
    return (
        <div className="daterange-picker-field__calendar">
            <CalendarHeader
                month={month}
                year={year}
                showLeftNav={showLeftNav}
                showRightNav={showRightNav}
                disableLeftNav={disableLeftNav}
                disablePreviousYear={disablePreviousYear}
                onPreviousYear={onPreviousYear}
                onPreviousMonth={onPreviousMonth}
                onNextMonth={onNextMonth}
                onNextYear={onNextYear}
            />

            <CalendarWeekdays weekdays={weekdays} />

            <CalendarDays
                days={days}
                onDayClick={onDayClick}
                onDayHover={onDayHover}
                onDayLeave={onDayLeave}
                getDayTooltip={getDayTooltip}
                getDayClassName={getDayClassName}
                hideOtherMonthDaysContent={hideOtherMonthDaysContent}
            />
        </div>
    );
});
